import {Component} from '@angular/core';
import {AbstractIcon} from '../abstract-icon';

@Component({
    selector: 'vui-people-icon',
    templateUrl: './people-icon.component.html',
    styleUrls: ['./people-icon.component.scss']
})
export class PeopleIconComponent extends AbstractIcon {
    constructor() {
        super();

        this.height = 28;
        this.width = 44;
    }
}
